import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-pale-dawn-dusk to-sunrise-red text-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-6 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
            {/* Copyright */}
            <div className="text-gray-300 text-sm order-2 md:order-1">
              <span>&copy; {currentYear} Journey.</span>
            </div>

            {/* Navigation */}
            <div className="flex flex-wrap justify-center md:justify-end items-center gap-4 order-1 md:order-2">
              <Link
                to="/videos"
                className="text-slate-cloud hover:text-red transition-colors duration-200 flex items-center"
              >
                <i className="fas fa-circle-play w-4 mr-2"></i>
                Videos
              </Link>
              <Link
                to="/changelog"
                className="text-slate-cloud hover:text-red transition-colors duration-200 flex items-center"
              >
                <i className="fas fa-history w-4 mr-2"></i>
                Changelog
              </Link>
              <Link
                to="/contact"
                className="text-slate-cloud hover:text-red transition-colors duration-200 flex items-center"
              >
                <i className="fas fa-envelope w-4 mr-2"></i>
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
